export const ds_RedirectPage_Entry = `
    fragment ds_RedirectPage_Entry on ds_RedirectPage_Entry {
        canonicalUid
        typeHandle
        redirectLink {
            linkUrl
            target
        }
    }
`